import { CSmartTable } from '@coreui/react-pro'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import PlayerService from 'src/service/PlayerService'
import PlayerStatTable from './PlayerStatTable'
import ClubService from 'src/service/ClubService'
import PlayerStatTableIndoor from './PlayerStatTableIndoor'

const PlayerStats = () => {
  const [loading, setLoading] = useState()
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(50)
  const [gameDetails, setGameDetails] = useState({})
  const [users, setUsers] = useState({})
  const [playerList, setPlayerList] = useState([])

  useEffect(() => {
    fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
  }, [activePage, columnFilter, columnSorter, itemsPerPage])

  useEffect(() => {
    const fetchGameAndPlayerData = async () => {
      try {
        setLoading(true)

        const [clubDetailsResponse, playerResponse] = await Promise.all([
          ClubService.getClubDetails(),
          PlayerService.getAllPlayer(),
        ])

        if (clubDetailsResponse) {
          setGameDetails(clubDetailsResponse.game_details)
        }

        if (playerResponse?.status === 200) {
          setPlayerList(playerResponse.data)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchGameAndPlayerData()
  }, [])

  const fetchData = (activePage, columnFilter, columnSorter, itemsPerPage) => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    PlayerService.playerStats(offset, itemsPerPage, activePage, params).then((result) => {
      setUsers(result.data)
      setLoading(false)
    })
  }

  var columns = [
    {
      label: 'Player Name',
      filter: true,
      sorter: true,
      key: 'player_name',
      _props: { color: 'dark' },
    },
    { label: 'FP', filter: false, sorter: true, key: 'sum_fp', _props: { color: 'dark' } },
    { label: 'POS', filter: false, sorter: true, key: 'position_name', _props: { color: 'dark' } },
    { label: 'RS', filter: false, sorter: true, key: 'sum_rs', _props: { color: 'dark' } },
    { label: '4S', filter: false, sorter: true, key: 'sum_fours', _props: { color: 'dark' } },
    { label: '6S', filter: false, sorter: true, key: 'sum_sixes', _props: { color: 'dark' } },
    { label: 'OVR', filter: false, sorter: true, key: 'sum_overs', _props: { color: 'dark' } },
    { label: 'MDN', filter: false, sorter: true, key: 'sum_mdns', _props: { color: 'dark' } },
    { label: 'WKS', filter: false, sorter: true, key: 'sum_wks', _props: { color: 'dark' } },
    { label: 'CS', filter: false, sorter: true, key: 'sum_cs', _props: { color: 'dark' } },
    { label: 'CWK', filter: false, sorter: true, key: 'sum_cwks', _props: { color: 'dark' } },
    { label: 'STS', filter: false, sorter: true, key: 'sum_sts', _props: { color: 'dark' } },
    { label: 'ROD', filter: false, sorter: true, key: 'sum_rods', _props: { color: 'dark' } },
    { label: 'ROA', filter: false, sorter: true, key: 'sum_roas', _props: { color: 'dark' } },
    { label: 'DKS', filter: false, sorter: true, key: 'sum_dks', _props: { color: 'dark' } },
    { label: 'HT', filter: false, sorter: true, key: 'sum_hattrick', _props: { color: 'dark' } },
  ]
  if (gameDetails?.game_type === 3) {
    columns = [
      {
        label: 'Player Name',
        filter: true,
        sorter: true,
        key: 'player_name',
        _props: { color: 'dark' },
      },
      { label: 'FP', filter: false, sorter: true, key: 'sum_fp', _props: { color: 'dark' } },
      {
        label: 'POS',
        filter: false,
        sorter: true,
        key: 'position_name',
        _props: { color: 'dark' },
      },
      { label: 'RS', filter: false, sorter: true, key: 'sum_rs', _props: { color: 'dark' } },
      { label: '1S', filter: false, sorter: true, key: 'sum_ones', _props: { color: 'dark' } },
      { label: '2S', filter: false, sorter: true, key: 'sum_twos', _props: { color: 'dark' } },
      { label: '3S', filter: false, sorter: true, key: 'sum_threes', _props: { color: 'dark' } },
      { label: '4S', filter: false, sorter: true, key: 'sum_fours', _props: { color: 'dark' } },
      { label: '5S', filter: false, sorter: true, key: 'sum_fives', _props: { color: 'dark' } },
      { label: '6S', filter: false, sorter: true, key: 'sum_sixes', _props: { color: 'dark' } },
      { label: '7S', filter: false, sorter: true, key: 'sum_sevens', _props: { color: 'dark' } },
      { label: '8S', filter: false, sorter: true, key: 'sum_eights', _props: { color: 'dark' } },
      { label: '9S', filter: false, sorter: true, key: 'sum_nines', _props: { color: 'dark' } },
      { label: 'OUTS', filter: false, sorter: true, key: 'sum_outs', _props: { color: 'dark' } },
      { label: 'OVR', filter: false, sorter: true, key: 'sum_overs', _props: { color: 'dark' } },
      { label: 'MDN', filter: false, sorter: true, key: 'sum_mdns', _props: { color: 'dark' } },
      { label: 'WKS', filter: false, sorter: true, key: 'sum_wks', _props: { color: 'dark' } },
      { label: 'CS', filter: false, sorter: true, key: 'sum_cs', _props: { color: 'dark' } },
      { label: 'CWK', filter: false, sorter: true, key: 'sum_cwks', _props: { color: 'dark' } },
      { label: 'STS', filter: false, sorter: true, key: 'sum_sts', _props: { color: 'dark' } },
      { label: 'ROD', filter: false, sorter: true, key: 'sum_rods', _props: { color: 'dark' } },
      { label: 'ROA', filter: false, sorter: true, key: 'sum_roas', _props: { color: 'dark' } },
      { label: 'DKS', filter: false, sorter: true, key: 'sum_dks', _props: { color: 'dark' } },
      { label: 'HT', filter: false, sorter: true, key: 'sum_hattrick', _props: { color: 'dark' } },
      { label: 'DOTB', filter: false, sorter: true, key: 'sum_dotb', _props: { color: 'dark' } },
    ]
  }

  return (
    <>
      {gameDetails?.game_type === 3 && (
        <PlayerStatTableIndoor
          users={users}
          activePage={activePage}
          setActivePage={setActivePage}
          columnFilter={columnFilter}
          setColumnFilter={setColumnFilter}
          columnSorter={columnSorter}
          setColumnSorter={setColumnSorter}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          columns={columns}
          fetchData={fetchData}
          setLoading={setLoading}
          loading={loading}
          playerList={playerList}
        />
      )}
      {gameDetails?.game_type !== 3 && (
        <PlayerStatTable
          users={users}
          activePage={activePage}
          setActivePage={setActivePage}
          columnFilter={columnFilter}
          setColumnFilter={setColumnFilter}
          columnSorter={columnSorter}
          setColumnSorter={setColumnSorter}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          columns={columns}
          fetchData={fetchData}
          setLoading={setLoading}
          loading={loading}
          playerList={playerList}
        />
      )}
    </>
  )
}

export default PlayerStats
